import React from 'react';
import { Route, useLocation } from 'wouter';
import Auth from './components/Auth';           // the file below
import Dashboard from './components/Dashboard';

export default function App() {
  return (
    <>
      {/* root path does the Microsoft/Cognito login flow */}
      <Route path="/" component={Auth} />

      {/* after auth, goes here */}
      <Route path="/dashboard" component={Dashboard} />
    </>
  );
}
